import $ from 'jquery';
import toastr from 'toastr';
import React, { useState, useEffect, forwardRef } from 'react';
import SessionManager from '../../routes/SessionManager';
import Activity from './Activity';
import Loading from '../Loading'
import bootbox from 'bootbox';
import Toastr from 'toastr';

/**
 * 
 * Step.1 : Get Default Template to have default threshold values.
 * Step.2 : Get Site Activities or SiteSupt Activity Templates.
 * Step.3 : Load first activity by default.
 * 
 */
let activityModified = null;
let curr_activity = null;

const SiteActivities = (props, refs) => {

    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let siteComponentRef = props.site_component;

    const [loading, setloading] = useState(true);
    const [activity, setactivity] = useState(null);
    const [customTemplate, setcustomTemplate] = useState(null);

    useEffect(() => {
        setloading('Fetching weather alerts ...');
        fetchSiteActivities();
    }, [props]);

    let onThresholdChange = (thresholdModified) => {
        let thresholds = JSON.parse(JSON.stringify(activityModified.activity_thresh_json));
        let i = 0;

        for (let threshold of thresholds) {
            if (thresholdModified.sensor_id === threshold.sensor_id) {
                let thresholdModifiedCopy = { ...thresholdModified };
                if (thresholdModifiedCopy.fieldName === "Humidity Change" || thresholdModifiedCopy.fieldName === "Temperature Change") {
                    thresholdModifiedCopy.alert_down = thresholdModifiedCopy.alert_down === "" ? "noop" : thresholdModifiedCopy.alert_down
                    thresholdModifiedCopy.alert_up = thresholdModifiedCopy.alert_up === "" ? "noop" : thresholdModifiedCopy.alert_up
                }
                // if (thresholdModifiedCopy.default) {
                //console.log('Deleted Threshold ... Loading default');
                //     let thresoldToLoad = activity.activity_thresh_json.filter((x) => x.sensor_id === threshold.sensor_id);
                //     if (thresoldToLoad.length > 0) {
                //         thresoldToLoad[0].default = true;
                //         //console.log('thresoldToLoad ', JSON.stringify(thresoldToLoad));
                //         thresholds[i] = thresoldToLoad[0];
                //     } else {
                //         thresholdModifiedCopy.default = true;
                //         thresholds[i] = thresholdModifiedCopy;
                //     }
                // } else {
                thresholds[i] = thresholdModifiedCopy;
                // }
            }
            i++;
        }
        activityModified.activity_thresh_json = thresholds;
        isActivityModified();
    }

    let fetchSiteActivities = () => {

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: { activity_scope: 1 }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/activity-thresholds/fetch',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data.length > 0) {
                        let activityTemplates = res.data[0];
                        let siteActivities = res.data[1];
                        let currActivity = null;
                        for (let activity of siteActivities) {
                            if (activity.activity_scope === 1) {
                                if (!Array.isArray(activity.activity_thresh_json)) {
                                    activity.activity_thresh_json = JSON.parse(activity.activity_thresh_json);
                                    // console.log(activity.activity_thresh_json)
                                }
                                currActivity = activity;
                                break;
                            }
                        };

                        let defaultTemplate = null;
                        for (let activity of activityTemplates) {
                            if (activity.activity_scope === 1 && activity.customer_id === 'template') {
                                if (!Array.isArray(activity.activity_thresh_json)) {
                                    activity.activity_thresh_json = JSON.parse(activity.activity_thresh_json);
                                }
                                defaultTemplate = activity;
                                // Make site default object
                                defaultTemplate.site_id = data.site_id;
                                defaultTemplate.customer_id = data.customer_id;
                                defaultTemplate.activity_id = activity.activity_id + 'SITESUPT';
                                break;
                            }
                        }
                        if (!currActivity && defaultTemplate) { // if no activity is found, then load default.
                            let siteActivityDefault = JSON.parse(JSON.stringify(defaultTemplate));
                            currActivity = siteActivityDefault;
                        }

                        // console.log('Site Activity : ', currActivity);
                        curr_activity = currActivity;
                        setloading(false);
                        setactivity(null);
                        setcustomTemplate(defaultTemplate);
                    } else {
                        setloading(false);
                    }
                }
            },
            (res) => {
                setloading(false);
            }
        );
    }

    useEffect(() => {
        if (customTemplate !== null) {
            onActivitySelected(curr_activity);
        }
    }, [customTemplate]);

    let onActivitySelected = (activitySelected) => {

        if (activitySelected === null) {
            return;
        }

        let activity = { ...activitySelected };

        // Add missing thresholds as defaults.
        let thresholdsFound = [];
        if (!$.isArray(activity.activity_thresh_json)) {
            activity.activity_thresh_json = JSON.parse(activity.activity_thresh_json);
        }

        for (let t of activity.activity_thresh_json) {
            thresholdsFound.push(t.sensor_id);
        }
        //console.log('customTemplate', customTemplate);
        var defaultThresholds = [];
        if (customTemplate) {
            defaultThresholds = JSON.parse(JSON.stringify(customTemplate.activity_thresh_json));
        }

        //console.log('DefaultThresholds', defaultThresholds);
        //console.log('ActivityThresholds', activity.activity_thresh_json);

        for (let t of defaultThresholds) {
            if (thresholdsFound.indexOf(t.sensor_id) === -1) {
                let tDefault = { ...t };
                tDefault.default = true;
                activity.activity_thresh_json.push(tDefault);
            }
        }

        let sensor_id_sort_order = ['weather_temperature', 'weather_humidity', 'weather_wind', 'weather_gust', 'weather_precip'];
        activity.activity_thresh_json = activity.activity_thresh_json.sort((x, y) => sensor_id_sort_order.indexOf(x.sensor_id) - sensor_id_sort_order.indexOf(y.sensor_id));

        activityModified = JSON.parse(JSON.stringify(activity));
        setloading(false);
        setactivity(JSON.parse(JSON.stringify(activity)));
        // this.setState({ loading: false, activity: JSON.parse(JSON.stringify(activity)) }, function () {
        //     this.isActivityModified();
        // });
    }

    useEffect(() => {
        isActivityModified();
    }, [activity]);

    let resetSiteSettings = () => {
        //this.setState({ loading: 'Fetching weather alerts ...' });
        let activityToReset = JSON.parse(JSON.stringify(activity));
        activityModified = JSON.parse(JSON.stringify(activity));
        setactivity(activityToReset)
    }

    React.useImperativeHandle(refs, () => ({
        resetSiteSettings,
        saveSiteSettings,
        deleteSiteSettings
    }));

    const isActivityModified = () => {
        function compareJSONObject(O1, O2) {
            var keys1 = Object.keys(O1);
            var keys2 = Object.keys(O2);
            //console.log('Keys Found: ', keys2);
            if (keys1.length === keys2.length && JSON.stringify(keys1.sort()) === JSON.stringify(keys2.sort())) {
                for (var k of keys1) {
                    if ($.isPlainObject(O1[k])) {
                        //console.log('Comparing Object ' + k, [O1[k], O2[k]])
                        return compareJSONObject(O1[k], O2[k]);
                    } else if ($.isArray(O1[k])) {
                        //console.log('Comparing Arrays ' + k, [O1[k], O2[k]])
                        return compareJSONArray(O1[k], O2[k], 'sensor_id');
                    } else {
                        //console.log('Comparing Values ' + k, [O1[k], O2[k]])
                        if (O1[k] !== O2[k]) {
                            //console.log('Values not matching ');
                            return false;
                        }
                    }
                }
            } else {
                //console.log('keys length not matching ');
                return false;
            }
            return true;
        }

        function compareJSONArray(O1, O2, key) {
            if (O1.length === O2.length) {
                let O1New = O1.sort((x, y) => { return x[key] - y[key] });
                let O2New = O2.sort((x, y) => { return x[key] - y[key] });
                for (var k in O1New) {
                    //console.log('Comparing Array Object' + JSON.stringify(k), [O1New[k], O2New[k]]);
                    let result = compareJSONObject(O1New[k], O2New[k]);
                    if (!result)
                        return result;
                }
            } else {
                return false;
            }
            return true;
        }

        let isModified = false;
        if (activity && activityModified) {
            let a = JSON.parse(JSON.stringify(activity));
            let b = JSON.parse(JSON.stringify(activityModified));

            //console.log('a', a);
            //console.log('b', b);

            let isNotModified = compareJSONObject(a, b);
            //console.log('isModified - 1 ' + isModified);
            if (isNotModified && (activityModified.activity_id + '').includes('SITESUPT')) {
                isModified = true;
            } else {
                isModified = !isNotModified;
            }
            //console.log('isModified - 2 ' + isModified);
        }

        siteComponentRef.changeDetected('site_activities', isModified);
        return isModified;
    }

    let saveSiteSettings = () => {

        //console.clear();

        // Step.1 Save Threshold
        // Step.2 Apply threshold to any new zones added.

        var data = { ...activityModified };

        var commonData = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            customer_id: user.customer_id
        };

        let thresholdsToSave = [];
        let thresholdsModified = JSON.parse(JSON.stringify(activityModified.activity_thresh_json));
        for (let threshold of thresholdsModified) {

            if (!threshold.default) {
                if (threshold.inputValidation && !threshold.inputValidation.isvalidtext) {

                    const position = toastr.options.positionClass
                    toastr.options.positionClass = 'toast-top-center';
                    toastr.error(threshold.inputValidation.invaliderrormsg)
                    toastr.options.positionClass = position;
                    return
                }
                else if (threshold.sensor_id && (threshold.sensor_id.toLowerCase().includes("temperature") || threshold.sensor_id.toLowerCase().includes("humidity"))) {
                    if (threshold.alert_down !== "noop" && !(Number(threshold.alert_down) < Number(threshold.alert_up))) {

                        const position = toastr.options.positionClass
                        toastr.options.positionClass = 'toast-top-center';
                        toastr.error(threshold.sensor_id + " : Drops below should be lower than rises above.")
                        toastr.options.positionClass = position;

                        return
                    }
                }
                thresholdsToSave.push(threshold);
            }
        }

        setloading('Saving weather alerts ...');

        for (let t of thresholdsToSave) {
            if (t.alert_timeout) {
                try {
                    t.alert_timeout = parseInt(t.alert_timeout);
                } catch (error) {
                    t.alert_timeout = 180;
                }
            }
            if (t.notify_me) {
                try {
                    t.notify_me = t.notify_me === 'true' || t.notify_me === true ? true : false;
                } catch (error) {
                }
            }
        }

        data.activity_thresh_json = JSON.stringify(thresholdsToSave);
        data.activity_thresh = data.activity_thresh_json;

        data.activity_scope = 1;
        data.site_id = user.site_selected.site_id;
        data.customer_id = user.customer_id;

        let activity_id_old = data.activity_id + '';
        if (activity_id_old.includes('SITESUPT')) {
            delete data.activity_id;
        }

        //console.log('data.activity_id : ' + data.activity_id);
        var operation = !data.activity_id || data.activity_id === 0 ? 'add' : 'modify';
        let payload = { ...commonData };
        payload.form_input = data;

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/activity-thresholds/' + operation,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(payload)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    //console.log('RESPONSE ', res.data);
                    Toastr.success("Local weather alerts saved successfully");
                    let activityAfterSaving = res.data.activity;

                    let site_activity = user.site_selected.site_activity;
                    //site_activity = "";
                    site_activity = site_activity ? (site_activity + "").split(':') : [];

                    let activity_id_new = activityAfterSaving.activity_id;
                    let steps = (site_activity.indexOf(activity_id_new + '') === -1) ? 2 : 1;

                    data.activity_id = activity_id_new;
                    // activity_id = activity_id_new; 
                    // Use this to pre-populate

                    if (steps === 1) {
                        onActivitySelected(activityAfterSaving);
                    } else {
                        let siteData = { ...commonData };

                        if (site_activity.indexOf(activity_id_new + '') === -1) {
                            site_activity.push(activity_id_new + '');
                        }

                        site_activity = site_activity.filter((x) => ((x + '').trim() !== '' && x !== undefined));
                        //console.log('site_activity', site_activity);
                        site_activity = (site_activity.sort().join(':')) + "";

                        siteData.form_input = {
                            customer_id: user.site_selected.customer_id,
                            site_id: user.site_selected.site_id,
                            site_activity: JSON.stringify(site_activity),
                            site_config: JSON.stringify(user.site_selected.site_config)
                        };

                        // let _context = this;
                        applyActivitytToSite(siteData, function (err, res) {
                            if (err) {
                                // _context.bootbox.status({ message: 'Error occured while saving weather alerts to site...', class: 'modal-full-width danger' });
                            } else {
                                //_context.bootbox.status({ message: 'Weather Alerts Site configuration successful !', class: 'modal-full-width success' });
                                user.site_selected.site_activity = site_activity;
                                for (let i = 0; i < user.site_locations.length; i++) {
                                    if (user.site_locations[i].site_id === user.site_selected.site_id) {
                                        user.site_locations[i].site_activity = site_activity;
                                    }
                                }
                                var sessionManager = new SessionManager();
                                sessionManager.storeCookie('user', { ...user });
                                setloading(false);
                                setactivity(null);
                                onActivitySelected(activityAfterSaving);
                            }
                        });
                    }

                }
            },
            (res) => {
                // refreshSiteActivities();
            });

    }

    let applyActivitytToSite = (data, cb) => {
        //console.log('Ajax: Saving Activity To Zone ', data);
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site-config/modify',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                cb(null, data.form_input);
            },
            (res) => {
                cb(new Error(), null);
            });
    }

    let deleteSiteSettings = () => {
        bootbox.dialog({
            closeButton: false,
            message: "Are you sure you want to delete the weather alert settings ?",
            buttons: [{
                label: 'No',
                callback: () => { }
            },
            {
                label: 'Yes',
                callback: () => { onConfirmDelete(activity.activity_id); }
            }]
        });
    }

    let onConfirmDelete = (activity_id) => {
        setloading('Deleting weather alerts ...');
        var siteData = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            customer_id: user.customer_id
        };

        let site_activity = user.site_selected.site_activity;
        site_activity = (site_activity + "").split(':').filter((x) => (x !== activity_id + '' && x + ''.trim() !== '' && x !== undefined));
        site_activity = site_activity.join(':');
        if (site_activity === "") {
            site_activity = " ";
        }

        siteData.form_input = {
            customer_id: user.site_selected.customer_id,
            site_id: user.site_selected.site_id,
            site_activity: site_activity + "",
            site_config: JSON.stringify(user.site_selected.site_config)
        };

        applyActivitytToSite(siteData, function (err, zonesModified) {
            var payload = {
                user_login: user.user_login,
                user_token: user.user_token,
                site_id: user.site_selected.site_id,
                customer_id: user.customer_id,
                form_input: { activity_id: activity_id }
            };

            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/activity-thresholds/delete',
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(payload)
                }
            ).then(
                (res) => {
                    if (res.status && res.status.code === 200) {
                        user.site_selected.site_activity = site_activity;
                        for (let i = 0; i < user.site_locations.length; i++) {
                            if (user.site_locations[i].site_id === user.site_selected.site_id) {
                                user.site_locations[i].site_activity = site_activity;
                            }
                        }
                        var sessionManager = new SessionManager();
                        sessionManager.storeCookie('user', { ...user });
                        Toastr.success("Deleted Successfully");
                        setactivity(null);
                        onActivitySelected(JSON.parse(JSON.stringify(customTemplate)));
                    }
                },
                (res) => {
                    bootbox.close();
                });
        });
    }
    let showDeleteBtn = (activity && activity.activity_id && !(activity.activity_id + '').includes('SITESUPT'));
    siteComponentRef.showOrHideDeleteButton(showDeleteBtn);
    return (
        <React.Fragment >
            {loading && <div className="row"><div className="col-md-12 p-2"><span className="ml-3"><Loading>{loading}</Loading></span></div></div>}
            {
                !loading && activity &&
                <React.Fragment>
                    <div className="row"><div className="col-md-12 p-2"><span className="ml-3"><i className="fa fa-info-circle text-primary"></i> <span className="font-size-12"><i>Default Alert Notification: Every 3 hours.</i></span></span></div></div>
                    <Activity activity={activity} onChange={onThresholdChange} refresh_id={new Date().getUTCMilliseconds()} weatherAlerts={true}></Activity>
                </React.Fragment>
            }
        </React.Fragment >
    );
}

export default forwardRef(SiteActivities);